const fetching = state => state.fetching;
const classes = state => state.classes;

export default {
  fetching,
  classes
}
